export default __webpack_public_path__ + "static/media/noa-21.9d8d20b6.jpg";